import {
  PendingTopup,
  usePendingTopups as usePendingTopupsQuery,
} from '@/src/api/payg';
import { useEffect } from 'react';
import { useTopupsRefresher } from './useTopupsRefresher';

export const usePendingTopups = ({
  topupSessionId,
}: {
  topupSessionId?: string;
}) => {
  const getPollInterval = (topups?: PendingTopup[]) => {
    if (!topups || topups.length === 0) {
      return false;
    }

    const isProcessing = topups.some(topup => topup.state === 'PROCESSING');
    const hasPendingPayment = topups.some(
      topup =>
        topup.topupSessionId === topupSessionId &&
        topup.state === 'PENDING_PAYMENT',
    );

    if (isProcessing || hasPendingPayment) {
      return 30000;
    }

    if (topups.some(topup => topup.state === 'AUTO_APPLY_DELAYED')) {
      return 60000;
    }

    return false;
  };

  const { data, refetch } = usePendingTopupsQuery({
    refetchInterval: getPollInterval,
  });

  useTopupsRefresher(data);

  useEffect(() => {
    if (topupSessionId) {
      refetch();
    }
  }, [topupSessionId, refetch]);

  return data;
};
